import i18next, { type i18n } from 'i18next';
import { initReactI18next } from 'react-i18next';
import enAdmin from './locales/en/admin.json';
import enClient from './locales/en/client.json';
import enCommon from './locales/en/common.json';
import deAdmin from './locales/de/admin.json';
import deClient from './locales/de/client.json';
import deCommon from './locales/de/common.json';

export const SUPPORTED_LANGUAGES = ['en', 'de'] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];

export const NAMESPACES = ['common', 'client', 'admin'] as const;
export type Namespace = (typeof NAMESPACES)[number];

export const DEFAULT_LANGUAGE: Language = 'en';

export const resources = {
  en: { common: enCommon, client: enClient, admin: enAdmin },
  de: { common: deCommon, client: deClient, admin: deAdmin },
} as const;

/** Creates a fresh i18next instance wired to react-i18next; no global state is shared. */
export function createI18n(lang: Language): i18n {
  const instance = i18next.createInstance();
  void instance.use(initReactI18next).init({
    resources,
    lng: lang,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    ns: [...NAMESPACES],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    initAsync: false,
    showSupportNotice: false,
  });
  return instance;
}
